<template>
  <div id="main-header">
    <div id="top-bar">
      <b-container>
        <b-row>
          <b-col md="4">
            <img v-if="siteType === 'ABC'" src="../assets/anthem-bc-logo.png" alt="Anthem Blue Cross" class="HeaderLogo AnthemBC">
            <img v-if="siteType === 'ABCBS'" src="../assets/anthem-bcbs-logo.png" alt="Anthem Blue Cross  and Blue Shield" class="HeaderLogo AnthemBCBS">
            <img v-if="siteType === 'EBCBS'" src="../assets/anthem-bc-logo.png" alt="Anthem Blue Cross" class="HeaderLogo AnthemBC">
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="home-banner banner animate">
      <div class="banner-img" style=""></div>
    </div>

    <div id="contentHeader">
      <b-row>
        <b-col class="text-center">
          <div class="headlineUnderline">
            <h2>What is a qualified expense?</h2>
            <em>
              Find out what expenses are qualified and non-qualified.
            </em>
          </div>
        </b-col>
      </b-row>
    </div>

  </div>
</template>

<script>
export default {
  data: function () {
    return {
      siteType: this.$parent.siteBrand
    }
  }
}
</script>
